import React from 'react';
import { observer } from 'mobx-react';
import { Footer } from '../../../common/footer';
import { HomeNavbar } from '../../../common/home-navbar';
import { InformationMenu } from '../information-menu';
import { ScreenStore } from '../../../stores/ScreenStore';
import { constants } from '../../../config';
import { CenterVenue, CenterVenue2x, CenterVenue3x, CenterVenueMobile, CenterVenueMobile2x, CenterVenueMobile3x, VazquezVenue, VazquezVenue2x, VazquezVenue3x, VazquezVenueMobile, VazquezVenueMobile2x, VazquezVenueMobile3x } from './img';
import { routeNaming, AppLink } from '../../../routes';
import styles from './VenuesAndOpenHours.css';
import { SEO } from '../../../common/seo';

const VenuesAndOpenHours = observer(() => {
  const showMobileVersion = ScreenStore.screenWidth <= constants.breakpoints.mobileThreshold;
  const showSmallVersion = ScreenStore.screenWidth <= constants.breakpoints.smallMaxWidth;
  return (
    <div className={styles.container}>
      <SEO
        title="Locales y horarios"
        description="Accede a toda la información relevante sobre Carlos Gutiérrez S.A, nuestros servicios, políticas y cómo podemos ayudarte. Encuentra detalles sobre nuestros productos, condiciones de uso, privacidad, envíos y más. Estamos comprometidos a ofrecerte la mejor experiencia, brindándote transparencia y claridad en todos nuestros procesos. Si tienes preguntas o dudas, esta sección es tu recurso principal para obtener respuestas. Descubre todo lo que necesitas saber y disfruta de una experiencia de compra segura y satisfactoria con nosotros"
        type="website"
      />
      <HomeNavbar />
      <div className={styles.mainWrapper}>
        <div className={styles.mainContent}>
          {showMobileVersion ?
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.INFORMATION_MENU_MOBILE}
              >
                Información
              </AppLink>
              <span> &gt; Locales y Horarios</span>
            </p>
            : <InformationMenu indexSelectedItem={3} />}
          <div className={styles.bodyContainer}>
            <h2 className={styles.subtitle}>Locales y horarios</h2>
            <div className={styles.contentContainer}>
              <div className={styles.contentSection}>
                <div className={styles.contentInformation}>
                  <h1 className={styles.contentSectionTitle}>Casa Central</h1>
                  <p className={styles.contentSectionSubtitle}>Dirección</p>
                  <p>Colonia 1372 casi Ejido</p>
                  <p className={styles.contentSectionSubtitle}>Horario</p>
                  <p>Lunes a Viernes de 9:00 a 19:00 hs.</p>
                  <p>Sábados de 9:00 a 13:00 hs.</p>
                  <p className={styles.contentSectionSubtitle}>
                    Estacionamiento gratuito
                    <span className={styles.weightNormal}>&nbsp;(30 minutos)</span>
                  </p>
                  <p>Torre Parking (Torre de los Profesionales)</p>
                  <p>Yaguarón 1411 casi Colonia</p>
                </div>
                <div className={styles.imageContainer}>
                  {showSmallVersion ?
                    <img src={CenterVenueMobile} srcSet={`${CenterVenueMobile2x} 2x, ${CenterVenueMobile3x} 3x`} alt="" className={styles.image} /> :
                    <img src={CenterVenue} srcSet={`${CenterVenue2x} 2x, ${CenterVenue3x} 3x`} alt="" className={styles.image} />}
                </div>
              </div>
              <div className={styles.contentSection}>
                <div className={styles.contentInformation}>
                  <h1 className={styles.contentSectionTitle}>18 y Vázquez</h1>
                  <p className={styles.contentSectionSubtitle}>Dirección</p>
                  <p>18 de Julio 1486 y Vázquez (a pasitos de El Gaucho)</p>
                  <p className={styles.contentSectionSubtitle}>Horario</p>
                  <p>Lunes a Viernes de 9:00 a 19:00 hs.</p>
                  <p>Sábados de 9:00 a 13:00 hs.</p>
                </div>
                <div className={styles.imageContainer}>
                  {showSmallVersion ?
                    <img src={VazquezVenueMobile} srcSet={`${VazquezVenueMobile2x} 2x, ${VazquezVenueMobile3x} 3x`} alt="" className={styles.image} /> :
                    <img src={VazquezVenue} srcSet={`${VazquezVenue2x} 2x, ${VazquezVenue3x} 3x`} alt="" className={styles.image} />}
                </div>
              </div>
              <div className={styles.contentSection}>
                <div className={styles.contentInformation}>
                  <h1 className={styles.contentSectionTitle}>Depósitos</h1>
                  <p className={styles.contentSectionSubtitle}>Direcciones</p>
                  <p>
                    De acuerdo al producto adquirido, retirará su compra en uno de
                    los siguientes depósitos:
                  </p>
                  <p className={styles.contentSectionSubtitle}>
                    Colonia 1385 casi Ejido:
                    <span className={styles.weightNormal}>
                      &nbsp;se retiran pequeños electrodomésticos, productos de electrónica y
                      televisores hasta 43&quot;.
                    </span>
                  </p>
                  <p className={styles.contentSectionSubtitle}>
                    Nicaragua 1679 casi Batoví:
                    <span className={styles.weightNormal}>
                      &nbsp;se retiran todo tipo de productos, a excepción de algunos pequeños
                      productos de electrónica.
                    </span>
                  </p>
                  <p className={styles.contentSectionSubtitle}>Horarios</p>
                  <p>Lunes a Viernes de 9:00 a 19:00 hs.</p>
                  <p>Sábados de 9:00 a 13:00 hs.</p>
                </div>
                <div className={styles.imageContainer} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
});

export { VenuesAndOpenHours };



// WEBPACK FOOTER //
// ./src/pages/information/venues-and-open-hours/VenuesAndOpenHours.jsx